import {
  getIncidentsRoutine,
  getIncidentStatsRoutine,
  getIncidentRoutine,
  generateSuggestionsRoutine,
  createIncidentRoutine,
  closeIncidentRoutine,
  CLEAR_INCIDENT_SUGGESTIONS,
} from './actions'

export const initialState = {
  incidents: [],
  incidentsMeta: null,
  incidentsLoading: false,
  incidentStats: null,
  currentIncident: null,
  currentLoading: false,
  currentError: null,
  suggestions: null,
  suggestionsLoading: false,
  mutationLoading: false,
  mutationError: null,
}

const replaceIncident = (list, updated) =>
  list.map(i => (i.id === updated.id ? { ...i, ...updated } : i))

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case getIncidentsRoutine.REQUEST: {
      // On a page-1 fetch (filters changed), wipe the list so the loading state
      // shows immediately instead of leaving stale rows from the previous filter.
      // Page > 1 (load more) keeps the existing rows for append.
      const isPageOne = (action.payload?.page ?? 1) === 1
      return {
        ...state,
        incidentsLoading: true,
        incidents: isPageOne ? [] : state.incidents,
        incidentsMeta: isPageOne ? null : state.incidentsMeta,
      }
    }
    case getIncidentsRoutine.SUCCESS: {
      const incoming = action.payload?.data ?? []
      const incomingMeta = action.payload?.meta ?? null
      // Page > 1 means the user is loading more — append to the existing list.
      // Page 1 (or no meta) means a fresh fetch — replace.
      const isFirstPage = !incomingMeta || incomingMeta.currentPage === 1
      const dedupeById = (list) => {
        const seen = new Set()
        return list.filter(x => x?.id && !seen.has(x.id) && seen.add(x.id))
      }
      return {
        ...state,
        incidentsLoading: false,
        incidents: isFirstPage ? incoming : dedupeById([...state.incidents, ...incoming]),
        incidentsMeta: incomingMeta,
      }
    }
    case getIncidentsRoutine.FAILURE:
      return { ...state, incidentsLoading: false }

    case getIncidentStatsRoutine.REQUEST:
      return { ...state, incidentStatsLoading: true }
    case getIncidentStatsRoutine.SUCCESS:
      return { ...state, incidentStatsLoading: false, incidentStats: action.payload?.data ?? null }
    case getIncidentStatsRoutine.FAILURE:
      return { ...state, incidentStatsLoading: false }

    case getIncidentRoutine.REQUEST:
      return { ...state, currentLoading: true, currentError: null }
    case getIncidentRoutine.SUCCESS:
      return { ...state, currentLoading: false, currentIncident: action.payload?.data ?? null }
    case getIncidentRoutine.FAILURE:
      return { ...state, currentLoading: false, currentError: action.payload || { message: 'Failed to load incident' } }

    case generateSuggestionsRoutine.REQUEST:
      return { ...state, suggestionsLoading: true, suggestions: null }
    case generateSuggestionsRoutine.SUCCESS:
      return { ...state, suggestionsLoading: false, suggestions: action.payload?.data ?? null }
    case generateSuggestionsRoutine.FAILURE:
      return { ...state, suggestionsLoading: false, mutationError: action.payload }

    case CLEAR_INCIDENT_SUGGESTIONS:
      return { ...state, suggestions: null, suggestionsLoading: false }

    case createIncidentRoutine.REQUEST:
    case closeIncidentRoutine.REQUEST:
      return { ...state, mutationLoading: true, mutationError: null }
    case createIncidentRoutine.SUCCESS: {
      const created = action.payload?.data
      if (!created) return { ...state, mutationLoading: false }
      return {
        ...state,
        mutationLoading: false,
        suggestions: null,
        incidents: [created, ...state.incidents],
        currentIncident: created,
      }
    }
    case closeIncidentRoutine.SUCCESS: {
      const updated = action.payload?.data
      if (!updated) return { ...state, mutationLoading: false }
      return {
        ...state,
        mutationLoading: false,
        incidents: replaceIncident(state.incidents, updated),
        currentIncident: state.currentIncident?.id === updated.id ? updated : state.currentIncident,
      }
    }
    case createIncidentRoutine.FAILURE:
    case closeIncidentRoutine.FAILURE:
      return { ...state, mutationLoading: false, mutationError: action.payload }

    default:
      return state
  }
}
